/** 
 * portatour website Common Javascript methods and objects. In one file to reduce HTTP calls.
 * Pricing, rentability, pLang
 * Leo
 *
 */

if (typeof console == "undefined" || typeof console.log == "undefined") var console = { log: function() {} }; 

var ptShop; // JSON payload added by server

if (typeof ptMessages != 'undefined')
	var ptMessages = {};


const closeTranslations = {
	de: "Schließen",
	fr: "Fermer",
	en: "Close",
	es: "Cerrar",
	pt: "Fechar",
	it: "Chiudere"
};

/**
 * pick the string following the lang, according to the lang in use
 * params: "langA", "valueA", "langB", "valueB", ...
 */
pLang_Language = $('html').attr('lang');
function pLang() {
	if ((arguments.length % 2) != 0)
		throw new Error("pLang requires an even amount of parameters. count="+arguments.length);
	i = 0;
	while (i<arguments.length) {
		if (arguments[i]==pLang_Language)
			return arguments[i+1];
		i+=2;
	}

	throw new Error("Cannot find language string for lang '"+pLang_Language+"' in parameters "+implode(',',arguments));
}

String.prototype.ptFormatUnicorn=function() { // http://stackoverflow.com/questions/610406/javascript-equivalent-to-printf-string-format
	var e=this.toString();
	if(!arguments.length) return e;
	var t=typeof arguments[0],n="string"==t||"number"==t?Array.prototype.slice.call(arguments):arguments[0];
	for(var i in n)e=e.replace(new RegExp("\\{"+i+"\\}","gi"),n[i]);
	return e;
}

function pLangF() {
	if ((arguments.length % 2) != 1)
		throw new Error("pLangF requires an uneven amount of parameters. count="+arguments.length);
	var argumentCopy = new Array(arguments.length-1); 
    for(var i = 0; i < argumentCopy.length; ++i) {
    	argumentCopy[i] = arguments[i];
    }
	var formatArgs = arguments[arguments.length-1];
	var msg = pLang.apply(null, argumentCopy);
	msg = msg.ptFormatUnicorn(formatArgs);
	return msg;
}

function isTouchDevice() {
	if(window.matchMedia("(pointer: coarse)").matches)
		return true;
	else
		return false;
}

/**
 * Get a translated text for the given string resource key.
 * Resources are required to be stored in ptmessages.php and ptmessages.php must be included as javascript source in the page's scripts.
 * @param key id of the string
 */
function pLang__(key) {
	if (typeof (ptMessages) == 'undefined') {
		ptClientErrorLog({caller:'pLang__', message:'No translation file loaded'});
		return '';
	} else
		if (typeof (ptMessages[key]) == 'undefined') {
			ptClientErrorLog({caller:'pLang__', message:'key '+key+' has no translation'});
			return '';
		} else
		return ptMessages[key];
}

/**
 * Get a translated text for the given string resource key, replace any appearance of {x} with the value of args[x].
 * Resources are required to be stored in ptmessages.php and ptmessages.php must be included as javascript source in the page's
 * @param key id of the string
 * @param args arguments to fill
 */
function pLangF__(key, args) {
	var s = pLang__(key);
	if (typeof (s) !== 'undefined' && typeof (args) != 'undefined') {
		s=s.ptFormatUnicorn(args);
	} 
	return s;
}

/**
 * get the date format for the current language
 */
function pGetDateFormat() {
	
	return pLang('de','d.m.yy', 'en', 'm/d/yy', 'fr', 'd.m.yy', 'es','dd/mm/yy', 'pt', 'dd/mm/yy', 'it','dd/mm/yy');
}

/**
 * Log this client js error on the server. 
 * @param data key/values. Typical values: "caller", "textStatus", ...
 * @param loggername String clienterrorlog is default as set by errorlog.php
 */
function ptClientErrorLog(data, loggername) {
	
	//FS#16564
	if(typeof	data['filename'] != 'undefined' && data['filename'].indexOf('matomo.js') != -1) {
		return;
	}
	
	if(loggername)
		data['logger_name'] = loggername;
		
	$.ajax({
		url:'/2013/errorlog.php',
		data: data
	});
}

/**
 * Log this client js error on the server and do a callback on complete
 * @param  data 		key/values. Typical values: "caller", "textStatus", ...
 * @param  function cb 		the callback function to be called on complete
 */
function ptClientErrorLogWithCB(data, cb) {
	
	$.ajax({
		url:'/2013/errorlog.php',
		data: data,
		complete: cb // if we need to call something before or after, extend it to  function() {cb();}
	});
	
}


/**
 * Register an error event listener to send errors to the server
 */
(function(){
	h=/__gCrWeb|Unbekannter Fehler|fidoCallback|dataKeys|NPObject/;
	c=/overrideWindowOpen/;
	l=/Script error\./;
	window.addEventListener("error",function(i) {
		console.log(i.message);
		if (
			!h.test(i.message)
			&& (!i.filename||i.filename==""||!("origin"in location)||i.filename.indexOf(location.origin)==0)
			&& i.filename!==undefined
			&& (i.filename!=""||!l.test(i.message))
		) {
			var data = {
				caller : 'windowErrorListener',
				message : i.message,
				filename : i.filename,
				lineno : i.lineno,
				colno : i.colno,
				userAgent : navigator.userAgent,
				locationhref : location.href,
			};
			try {
				data.stack = i.error.stack;
				if (c.test(""+i.error.stack))
					return;
			} catch (e) {
				data.stack = 'not found';
			}
			ptClientErrorLog(data);
		}
	});
})();

/**
 * Graphical initializations
 * Tooltips using jQuery, especially on touch devices this helps 
 */


$(document).ready(function() {

	var _addtooltips = $( '.feature-info-icon,.touch-tool-tip,.tooltipPersonen' );
	if (_addtooltips.length && ('undefined' != typeof(jQuery().tooltip)))  {
		_addtooltips.tooltip (
		{
			content: function() {
				var element = $( this );
				var s = element.attr('title');
				
				if($(this).hasClass('tooltipPersonen'))	s = pLang__('persontooltip');
				
				if ('' == s)
					return null;

				if (isTouchDevice())
					s += "<div class='float: right;'><a href=\"javascript:$('.feature-info-icon').tooltip('close');\" class='touchTooltipHack'>"+(closeTranslations[ptCommon.language]).toLowerCase()+"</a></div>";

				return s;
			},
			create: function(ev, ui) {
				
				if($(this).hasClass("tooltipPersonen")) {
					$(this).attr('title', pLang__('persontooltip'));
				}
				
	      $(this).data("ui-tooltip").liveRegion.remove();
	   	} 
		});
	}
	
	// contact fancybox in menu and on other places, if fancybox is used
	if ('undefined' != typeof(jQuery().fancybox))
		$('.fancyframe').fancybox({
			type: 'iframe',
			iframe : {
        css : {
          width: '1024px'
        }
	    },
			minHeight : 400
		});
	
	ptExtendPageForFooter(); // initially is enough. No need to do that on resize
	

	// click handler for paymenttype checkboxes
	if($('ul.paymentTypes').length > 0)
		$('ul.paymentTypes').on('click','div.check', function(e) { 
			$(this).prev().trigger('click');
			if(typeof ptShopPaymentTypeChanged == "function")
				ptShopPaymentTypeChanged();
		});
	
	//find correct scroll to position for licence term privacy hash
	if(window.location.pathname.indexOf('license-terms') != -1 && window.location.hash == '#privacy-policy') {
		$('html, body').stop().animate({ scrollTop: $('#privacy-policy').offset().top - $('.header-container').height() }, 750);	
	} 
});

/**
 * Check if the page is too small so that there is white below the footer. If so, add margin before footer
 */
function ptExtendPageForFooter () {
	var fc = $('.colorBGContainer.footer, .footer-container'); //remove .footer-container when everythins is boilerplate :)
	if (fc) {
		var wh = $(window).outerHeight();
		var dh = $('html').height();
		if (dh < wh) {
			var mrgn = (wh-dh) + 'px';
			fc.css('margin-top', mrgn);
		}
	}
}

/*
 * For pages with a long menu which can't be css'ed
 */
function ptFirstContainerDynamic() {
	// firstcontainer height depending on header
	var onWinResizeFirstContainer = function() {
		var firstContainer = $('.first-container');
		if (!firstContainer.length)
			return;
		var header = $('.header-container')
		if (!header.length)
			return;
		firstContainer.css({ 'margin-top' : header.outerHeight() + 'px'});
		console.log(".first-container: margin-top: " + header.outerHeight() + 'px;');
	}
	$( window ).resize(onWinResizeFirstContainer);
	onWinResizeFirstContainer();
}


/**
 * Show the state field for USA and Australia. Hide it for D/A/CH and all other countries.
 * This initializes the state based on the current value of qCountry and also registers a change-event-handler to the qCountry.
 * @param {jQuery} qState the state element to show/hide
 * @param {jQuery} qCountry the country selector to read
 **/
function showStateForCountry(qState, qCountry) {
	if (!qState.length)
		throw "qState is emtpy";
	if (!qCountry.length)
		throw "qCountry is empty";
	var handler = function (e) {
		// javascripts scoping and closure: qState and qCountry are bound here forever. To also call this below, the parameter e is ignored but the closure parameters are used.
		var country = qCountry.val();
		if ((country!='')&&(-1!=jQuery.inArray(country, ptCommon.pCountriesWithStateInAddress))) {
			qState.show();
		} else {
			qState.hide();
		}
	}
	// register the handler
	qCountry.on('change', handler);
	// and call it once
	handler();
}


/**
 * Number formatting.
 */
function PtNumber() {
	this.dec_point = ','; // will be updated by initNumberLocalization
	this.thousands_sep = '.';
	this.inited = false;
}
/**
 * split a dd.cc number into dd<sup>cc</sup>
 */
PtNumber.prototype.niceifyNumber = function(number) {
	this.initNumberLocalization();
	coins = Math.round(100*(number-Math.floor(number)));
	return Math.floor(number)+this.dec_point+"<sup>"+(coins<10?'0':'')+coins+"</sup>";
}
/**
 * return a formatted number
 * Requires ptShop
 * @param float number the number to print
 * @param int decimals how many decimals after the separator (default: 0)
 * @param showCurrency false to hide, true to show, 
 * 		'spaced' to show with a space between number and currency when showing EUR
 * 		'plaintext' to show the currency as plaintext, not as HTML 
 */
PtNumber.prototype.sprintNumber = function(number, decimals, showCurrency) {
	this.initNumberLocalization();
	decimals = typeof decimals !== 'undefined' ? decimals : 0;
	showCurrency = typeof showCurrency !== 'undefined' ? showCurrency : false;
	// FS#11000 special format for brazil
	if((typeof ptShop != 'undefined') && ptShop.country == "BR" && showCurrency) {
		decimals = 2;
	} 
	
	var result = $.number(Math.abs(number),decimals,this.dec_point,this.thousands_sep);
	var space = '';
	var currency = '';
	switch (showCurrency) {
		case 'spaced' : 
			space = '&nbsp;'; 
		case true: 
			currency = '<span class="currencysymbol">'+ptShop.currencySymbolHtml+'</span>';
			break;
		case 'plaintext' : 
			currency = ptShop.currencySymbol; 
			break;
	}
	// placement of currency symbol depends on localization and currency. EN/USD has before, DE/EUR after
	if (showCurrency) {
		if ('EUR'==ptShop.currency) {
			result = result + space + currency;
		} else {
			result = currency + result;
		}
	}
    // put "-" in front
	if(number < 0) {
		result = "-" + result;
	}
	return result;
}
// parse number using the same methods that jquery.number.js does
PtNumber.prototype.sparseNumber = function(numberstring) {
	this.initNumberLocalization();
	return parseFloat(numberstring
				.replace( this.thousands_sep, '', 'g' )
				.replace( this.dec_point, '.' ));
}
PtNumber.prototype.initNumberLocalization = function() {
	if (this.inited)
		return;
	if ((typeof ptShop == 'undefined')||(typeof ptShop.country == 'undefined')||(ptShop.country == null))
		return; // leave default
	// from jquery.numberformatter, taken here under the MIT license they offer
	var nfLocales = new Object();
	var nfLocalesLikeUS = [ 'ae','au','ca','cn','eg','gb','hk','il','in','jp','sk','th','tw','us' ];
	var nfLocalesLikeDE = [ 'at','br','de','dk','es','gr','it','nl','pt','tr','vn' ];
	var nfLocalesLikeFR = [ 'cz','fi','fr','ru','se','pl' ];
	var nfLocalesLikeCH = [ 'ch' ];
	var nfLocaleFormatting = [ [".", ","], [",", "."], [",", " "], [".", "'"] ]; 
	var nfAllLocales = [ nfLocalesLikeUS, nfLocalesLikeDE, nfLocalesLikeFR, nfLocalesLikeCH ];
	// write the arrays into the hashtable
	for (var localeGroupIdx = 0; localeGroupIdx < nfAllLocales.length; localeGroupIdx++) {
		localeGroup = nfAllLocales[localeGroupIdx];
		for (var i = 0; i < localeGroup.length; i++) {
			nfLocales[localeGroup[i]] = localeGroupIdx;
		}
	}
	// lookup to match locale with codes
	var codesIndex = nfLocales[ptShop.country.toLowerCase()];
	if (typeof codesIndex !== 'undefined') {
		var codes = nfLocaleFormatting[codesIndex];
		if (codes) {
			this.dec_point = codes[0];
			this.thousands_sep = codes[1];
		}
	}
	this.inited=true; 
}

PtNumber.prototype.countDecimals = function (x) {
  if(Math.floor(x.valueOf()) === x.valueOf()) return 0;
  
  if(typeof x.toString().split(".")[1] != 'undefined')
 		return x.toString().split(".")[1].length 
 	else return 0; 
}


ptNumber = new PtNumber();

/**
 * Update the shop parameters
 */
function ptShopUpdateShopParameters(billingCountry) {
	/* Using POST to get the data, GETs are cached and the caching may lose the query-string in some jQuery instances. See FS#5049 */
	var data = {'language': ptCommon.language};
	
	if ((typeof billingCountry !== 'undefined') && (billingCountry.trim() != '')) 
		data.billingCountry = billingCountry;
	
	$.ajax({
		url: '/shop/UpdateShopParameters',
		type: 'POST',
		data: data,
		dataType: 'json',
		success : function(data, textStatus, jqXHR) {
			window.ptShop = data;
			jQuery(document).trigger('ptShopCurrencyLoaded', data);
		},
		error:function(jqXHR, textStatus, errorThrown ){
			try {				
				if (jqXHR.readyState == 0 || jqXHR.status == 0) {  
					return; //Probably user aborted load by navigating away.  FS#6303
				}  
			} catch (e) { }
			
			var log = {caller:'ptcommon.js:ptShopUpdateShopParameters',textStatus: textStatus, errorThrown: errorThrown, data: data};
			try { log.jqXHRstatus	= jqXHR.status; } catch (e) { }
			try { log.jqXHRstatusText	= jqXHR.statusText; } catch (e) { }
			try { log.jqXHRresponseText	= jqXHR.responseText; } catch (e) { }
			// log the error for debugging
			ptClientErrorLog(log);
			if (typeof console != "undefined") {
				console.log('Error loading page: '+textStatus+'. '+errorThrown);
			}
		}
	});
}

/**
 * Initiate loading of shop, ptShopCurrencyLoaded will be triggered. Call this in $(document).ready()
 */
function ptStartShopCurrencyLoad() {
	// load shop data
	if ((typeof (ptShop) == "object") && (ptShop.currency)) {
		/* the currency&country payload is already delivered, go on straight ahead */
		jQuery(document).trigger('ptShopCurrencyLoaded', ptShop);
	} else {
		ptShopUpdateShopParameters();
	}
}

/**
 * send a google analytics event (GA4)
 * @param  String ga4Event	GA4 event name
 * @param  Object ga4Params	GA4 parameters or {} to signal no params
 * @param  String caller   (for error logging) file that calls that specific event eg. "example.js"
 * @param  String logMsg   (for error logging) message to display on send error
 */
function pSendGAEvent(ga4Event, ga4Params, caller, logMsg) {
  //GA4
  if(typeof gtag == 'undefined')
  	return;
  	
  try {
    gtag('event', ga4Event, ga4Params);
  } catch (e) {
    ptClientErrorLog({function: 'pSendGAEvent', caller: caller, errorThrown: e, message: logMsg });
  }
}
